import { useHistory } from 'react-router';
import { Grid, Typography, Button, Box } from '@mui/material';

const PlateNotFound = () => {
  const history = useHistory();

  const handleButton = () => {
    history.push('/');
  };

  return (
    <Box>
      <Grid
        container
        direction="column"
        alignItems="center"
        justifyContent="center"
        sx={{
          padding: { xs: '8px', md: '40px' },
          backgroundColor: '#F6F6F6',
          minHeight: '100vh',
        }}
      >
        <Typography
          variant="h5"
          align="center"
          sx={{
            color: '#000000',
            fontWeight: 600,
            fontSize: { xs: '20px', md: '24px' },
            padding: { xs: '12px', md: '20px' },
            textAlign: 'center',
          }}
        >
          Lo sentimos, esta promoción ya no está disponible
        </Typography>

        <Button
          variant="contained"
          color="primary"
          onClick={handleButton}
          sx={{
            mt: 2,
            px: 4,
            py: 1,
            borderRadius: '8px',
            fontWeight: 600,
            textTransform: 'none',
          }}
        >
          Volver al inicio
        </Button>
      </Grid>
    </Box>
  );
};

export default PlateNotFound;
